module.exports = __webpack_public_path__ + "img/7-1_04.5c85fbbd.jpg";